import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import ManualLabourDetailsForm from "../../../components/forms/setup/manualLabour/ManualLabourDetailsForm";
import { BannerNotificationType } from "../../../components/SimpleNotification";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";

export function ManualLaboursViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [manualLabours, setManualLabours] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getManualLabours = async function (search, page) {
    setLoading(true);

    const payload = {
      page: page,
      search: search || "",
    };

    let callResult = await makePostApiCall("manualLabours", payload);
    setLoading(false);
    if (callResult.success) {
      setManualLabours(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createManualLabour = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("manualLabours/create", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Manual Labour added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getManualLabours("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateManualLabour = async function (values, index) {
    let callResult = await makePutApiCall(`manualLabours/${values.id}`, values);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Manual Labour updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      getManualLabours("", 1);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddManualLabourSlideOver = (isEdit, item, index) => {
    setSlideOver({
      childComponent: (
        <ManualLabourDetailsForm
          item={item}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit
              ? updateManualLabour(payload, index)
              : createManualLabour(payload)
          }
          title={
            isEdit ? `Update ${item.labour_type}` : "Add new manual labour"
          }
        />
      ),
      open: true,
    });
  };

  const deleteManualLabour = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteManualLabour/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = manualLabours.data.filter((item) => item.id !== id);
      setManualLabours({ ...manualLabours, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteManualLabour = function (item, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteManualLabour(item.id, index)}
          message={`Are you sure you want to delete ${item.labour_type}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddManualLabourSlideOver,
    getManualLabours,
    loading,
    manualLabours,
    setSlideOver,
    slideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    askDeleteManualLabour,
  };
}
